import {EntityService} from '../../../service/EntityService';

import {AppStorage} from '../../../service/UserStorage';

export class CurrencyService extends EntityService {

  static entity = 'app/currency';

  static create(data: any): Promise<any> {
    data.tenantCompanyId = AppStorage.get('tenant');
    return super.create(data);
  }

  static update(id: string, data: any): Promise<any> {
    data.tenantCompanyId = AppStorage.get('tenant');
    return super.update(id, data);
  }

}
